<template>
    <div class="divMessaggio" :class="$store.state.MessaggioGlobale.alertClass" v-if="$store.state.MessaggioGlobale.mostraMessaggio">
        <template v-if="fontawesome == 'embedded'">
            <font-awesome-icon :icon="$store.state.MessaggioGlobale.alertIcon" v-if="$store.state.MessaggioGlobale.alertIconSpin" spin />
        <!-- <font-awesome-icon :icon="['fa-solid','fa-spinner', 'spin']" v-if="$store.state.MessaggioGlobale.alertIconSpin" /> -->
        <font-awesome-icon :icon="$store.state.MessaggioGlobale.alertIcon" v-else  />
        </template>
        <template v-else>
            <i v-if="$store.state.MessaggioGlobale.alertIconSpin" class="fas fa-spinner fa-spin"></i>
            <i v-else  :class="'fas ' + $store.state.MessaggioGlobale.alertIcon"></i>
        </template>
        &nbsp;
        {{ProcessaTestoMessaggio()}}
    </div>
</template>

<script>


export default {
 name: "MessaggioGlobale",   
 props: {
   fontawesome: {
    type: String,
    default: "embedded"
   }
 },
 data: function () {
    return {
      
    }
 },
 methods: {
    ProcessaTestoMessaggio() {
        let msg = '';
        for(let i=0; i<this.$store.state.MessaggioGlobale.alertMessaggio.length; i++) {
            msg += this.$store.state.MessaggioGlobale.alertMessaggio[i] + " ";
        }
        return msg;
    }  
 },
 watch: {
   
 },
 mounted: function() {
    
    
 }
 
}

</script>

<style scoped>
    .divMessaggio {
        margin-top:15px;
        line-height: 13px;
        font-weight: 0;
        
    }

</style>
